export default "__VITE_ASSET__Cgi7Qndl__"